/* ============================================================
   JAFFARY — Shopify Theme JS
   Vanilla JS · No dependencies
   ============================================================ */

(function () {
  'use strict';
  /* ── Currency-aware money formatting (follows Shopify localization) ── */
  function jaffaryActiveCurrency() {
    try { if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active; } catch (e) {}
    return 'USD';
  }
  function jaffaryMoney(cents, decimals) {
    var d = (decimals === 0) ? 0 : 2;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: jaffaryActiveCurrency(), minimumFractionDigits: d, maximumFractionDigits: d }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(d); }
  }


  /* ─── Fade-in on scroll ─────────────────────────────────── */
  function initFadeIn() {
    var els = document.querySelectorAll('.fade-in-up, .fade-in');
    if (!els.length) return;
    // Opt in to the fade animation only now that JS is alive
    document.documentElement.classList.add('js-ready');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
    // Safety net: if anything is still hidden after 2s (slow device/observer
    // hiccup), reveal it — a product must never stay invisible.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }, 2000);
  }

  /* ─── Header scroll + theme detection ─────────────────── */
  function initHeader() {
    var header = document.querySelector('.jaffary-header');
    if (!header) return;
    var prevY = 0;
    var ticking = false;

    function detectTheme() {
      var sections = document.querySelectorAll('[data-header-theme]');
      var checkY = 30;
      sections.forEach(function (s) {
        var rect = s.getBoundingClientRect();
        if (rect.top <= checkY && rect.bottom > checkY) {
          var theme = s.getAttribute('data-header-theme') || 'light';
          header.classList.toggle('header--dark', theme === 'dark');
          header.classList.toggle('header--light', theme !== 'dark');
        }
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        /* Homepage: header stays fully transparent — never toggle the scrolled state (was causing a hairline flicker under the logo) */
        if (!header.classList.contains('header--home')) {
          header.classList.toggle('header--scrolled', y > 50);
        }
        /* Hide-on-scroll-down mirrors React Header.tsx: only on product pages, only on mobile */
        var isProductPage = window.location.pathname.indexOf('/products/') === 0;
        var isDesktop = window.innerWidth >= 1024;
        if (isProductPage && !isDesktop && y > 120) {
          header.classList.toggle('header--hidden', y > prevY);
        } else {
          header.classList.remove('header--hidden');
        }
        prevY = y;
        detectTheme();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    detectTheme();
    setTimeout(detectTheme, 400);
  }

  /* ─── Mobile Menu ───────────────────────────────────────── */
  function initMenu() {
    var drawer = document.getElementById('menu-drawer');
    var overlay = document.getElementById('menu-overlay');
    var closeBtn = document.getElementById('menu-close');
    var header = document.querySelector('.jaffary-header');
    if (!drawer) return;

    function setToggleBtns(opened) {
      document.querySelectorAll('[data-menu-toggle]').forEach(function(btn) {
        btn.classList.toggle('is-open', opened);
        btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
        btn.setAttribute('aria-label', opened ? 'Close menu' : 'Open menu');
      });
    }
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (header) header.classList.add('header--menu-open');
      setToggleBtns(true);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (header) header.classList.remove('header--menu-open');
      setToggleBtns(false);
    }

    // Hamburger button: toggle open/close
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function() {
        drawer.classList.contains('is-open') ? close() : open();
      });
    });
    // Legacy data-menu-open buttons (bottom nav etc)
    document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Section toggles
    document.querySelectorAll('.menu-section__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.menu-section');
        section.classList.toggle('is-expanded');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ─── Search Overlay ────────────────────────────────────── */
  function initSearch() {
    var overlay = document.getElementById('search-overlay');
    if (!overlay) return;
    var input = document.getElementById('search-overlay-input');
    var closeBtn = overlay.querySelector('.search-overlay__close');
    var defaultState = document.getElementById('search-default-state');
    var resultsState = document.getElementById('search-results-state');
    var resultsInner = document.getElementById('search-results-inner');
    var searchTimer = null;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (input) input.value = '';
      showDefault();
    }
    function showDefault() {
      if (defaultState) defaultState.style.display = '';
      if (resultsState) resultsState.style.display = 'none';
    }
    function showResults(html) {
      if (defaultState) defaultState.style.display = 'none';
      if (resultsState) resultsState.style.display = '';
      if (resultsInner) resultsInner.innerHTML = html;
    }

    function doSearch(q) {
      if (!q) { showDefault(); return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            showResults('<p class="search-overlay__no-results">No results found</p>');
            return;
          }
          var html = products.map(function (p) {
            var img = p.featured_image ? p.featured_image.url : '';
            var price = p.price ? jaffaryMoney(parseInt(p.price, 10), 0) : '';
            return '<a href="' + p.url + '" class="search-overlay__product" onclick="document.getElementById(\'search-overlay\').classList.remove(\'is-open\');document.body.style.overflow=\'\';">'
              + '<div class="search-overlay__product-img">'
              + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '')
              + '</div>'
              + '<p class="search-overlay__product-name">' + p.title + '</p>'
              + '<p class="search-overlay__product-price">' + price + '</p>'
              + '</a>';
          }).join('');
          showResults(html);
        })
        .catch(function () {
          showResults('<p class="search-overlay__no-results">No results found</p>');
        });
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = input.value.trim();
        if (!q) { showDefault(); return; }
        searchTimer = setTimeout(function () { doSearch(q); }, 280);
      });
    }

    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter' && input) {
        var q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
  }

  /* ─── Cart Drawer ───────────────────────────────────────── */
  function initCart() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    var closeBtn = document.getElementById('cart-close');
    var body = document.getElementById('cart-body');
    var footer = document.getElementById('cart-footer');
    var subtotalEl = document.getElementById('cart-subtotal-amount');
    var openBtns = document.querySelectorAll('[data-cart-open]');

    if (!drawer) return;

    function formatMoney(cents) {
      return jaffaryMoney(cents);
    }

    function renderCart(cart) {
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p></div>';
        if (footer) footer.style.display = 'none';
        return;
      }
      if (footer) footer.style.display = 'block';

      var totalDiscount = cart.total_discount || 0;
      if (subtotalEl) {
        if (totalDiscount > 0) {
          subtotalEl.innerHTML = '<s style="color:#999;font-weight:400;margin-right:8px;">' + formatMoney(cart.original_total_price) + '</s>' + formatMoney(cart.total_price);
        } else {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
      }

      // Discount row: collect unique discount code titles from cart + line level
      var discountRow = document.getElementById('cart-discount-row');
      if (discountRow) {
        if (totalDiscount > 0) {
          var titles = [];
          (cart.cart_level_discount_applications || []).forEach(function (d) {
            if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title);
          });
          cart.items.forEach(function (item) {
            (item.line_level_discount_allocations || []).forEach(function (a) {
              var t = a.discount_application && a.discount_application.title;
              if (t && titles.indexOf(t) === -1) titles.push(t);
            });
          });
          var labelEl = document.getElementById('cart-discount-label');
          var amountEl = document.getElementById('cart-discount-amount');
          if (labelEl) labelEl.textContent = titles.length ? titles.join(', ') : 'Discount';
          if (amountEl) amountEl.textContent = '\u2212' + formatMoney(totalDiscount);
          discountRow.style.display = 'flex';
        } else {
          discountRow.style.display = 'none';
        }
      }

      var html = '';
      cart.items.forEach(function (item) {
        var hasDisc = item.original_price > item.final_price;
        var priceHtml = hasDisc
          ? '<s style="color:#999;font-weight:400;margin-right:6px;">' + formatMoney(item.original_price) + '</s>' + formatMoney(item.final_price)
          : formatMoney(item.final_price);
        var discLabels = '';
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var t = a.discount_application && a.discount_application.title;
          if (t) discLabels += '<div style="font-size:10px;color:#1a3a2a;letter-spacing:0.04em;margin-top:2px;">' + t + ' \u2212' + formatMoney(a.amount) + '</div>';
        });
        html += '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__image"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' +
          '<div class="cart-item__info">' +
          '<div class="cart-item__name">' + item.product_title + '</div>' +
          '<div class="cart-item__meta">' + (item.variant_title || '') + '</div>' +
          '<div class="cart-item__price">' + priceHtml + '</div>' +
          discLabels +
          '<div class="cart-item__bottom">' +
          '<div class="cart-item__qty">' +
          '<button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
          '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
          '<button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
          '</div></div>';
      });
      body.innerHTML = html;

      // Bind quantity / remove buttons
      body.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var action = btn.getAttribute('data-action');
          var key = btn.getAttribute('data-key');
          var qty = parseInt(btn.getAttribute('data-qty') || '0', 10);
          if (action === 'remove') qty = 0;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); updateCartCount(cart.item_count); });
        });
      });
    }

    function fetchCart() {
      if (body) body.innerHTML = '<div class="cart-loading"><div class="cart-spinner"></div></div>';
      fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
    }

    function openCart() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchCart();
      document.dispatchEvent(new CustomEvent('cart-open'));
    }
    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('cart-close'));
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openCart); });
    if (overlay) overlay.addEventListener('click', closeCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);

    // Intercept add-to-cart forms to use AJAX
    // Guard: if form already handled by a more-specific handler (product page), skip
    document.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;
      var sizeSelected = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
      if (!sizeSelected) return;
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      }).then(function (r) { return r.json(); }).then(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          openCart();
        });
      }).catch(function (err) { console.warn('Add to cart error:', err); });
    });

    // Listen for custom event from product page JS
    document.addEventListener('cart:open', openCart);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ─── Product Gallery (mobile swipe) ───────────────────── */
  function initProductGallery() {
    var gallery = document.querySelector('.gallery-scroll');
    if (!gallery) return;
    var progressBar = document.querySelector('.gallery-progress__bar');
    var counter = document.querySelector('.gallery-counter__num');
    var slides = gallery.querySelectorAll('.gallery-slide');
    var total = slides.length;

    function update() {
      var maxScroll = gallery.scrollWidth - gallery.clientWidth;
      if (maxScroll <= 0) return;
      var progress = gallery.scrollLeft / maxScroll;
      var current = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      if (progressBar) {
        progressBar.style.width = (100 / total) + '%';
        progressBar.style.transform = 'translateX(' + ((current - 1) * 100) + '%)';
      }
      if (counter) counter.textContent = current + ' / ' + total;
    }

    gallery.addEventListener('scroll', update, { passive: true });
    update();

    // Expand button
    var expandBtn = document.querySelector('.gallery-counter__expand');
    var fullscreen = document.querySelector('.fullscreen-gallery');
    var fsClose = document.querySelector('.fullscreen-gallery__close');
    if (expandBtn && fullscreen) {
      expandBtn.addEventListener('click', function () {
        fullscreen.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (fsClose) {
      fsClose.addEventListener('click', function () {
        fullscreen.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Desktop thumbnails
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var mainImg = document.querySelector('.product-gallery-desktop__main img');
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.getAttribute('data-src') || thumb.querySelector('img').src;
      });
    });
  }

  /* ─── Product Page: Size selector ─────────────────────── */
  function initSizeSelector() {
    var sizeBtns = document.querySelectorAll('.size-btn:not(.is-sold-out)');
    var hiddenInput = document.querySelector('[name="id"]');
    if (!sizeBtns.length) return;

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var variantId = btn.getAttribute('data-variant-id');
        if (hiddenInput && variantId) hiddenInput.value = variantId;
      });
    });
  }

  /* ─── Product Accordions ────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('.accordion-item__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.accordion-item');
        item.classList.toggle('is-open');
      });
    });
  }

  /* ─── Footer Accordion ──────────────────────────────────── */
  function initFooterAccordion() {
    document.querySelectorAll('.footer__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var icon = btn.querySelector('.footer__accordion-icon');
        var isOpen = body && body.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.footer__accordion-body').forEach(function (b) { b.classList.remove('is-open'); });
        document.querySelectorAll('.footer__accordion-icon').forEach(function (i) { i.classList.remove('is-open'); });
        // Open clicked if was closed
        if (!isOpen && body) {
          body.classList.add('is-open');
          if (icon) icon.classList.add('is-open');
        }
      });
    });
  }

  /* ─── Collection Filter ─────────────────────────────────── */
  function initCollectionFilter() {
    var filterBtns = document.querySelectorAll('.filter-btn[data-tag]');
    if (!filterBtns.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-tag');
        var url = new URL(window.location.href);
        if (tag) {
          url.searchParams.set('tag', tag);
        } else {
          url.searchParams.delete('tag');
        }
        window.location.href = url.toString();
      });
    });

    // Mark active filter from URL
    var currentTag = new URLSearchParams(window.location.search).get('tag') || '';
    filterBtns.forEach(function (btn) {
      if ((btn.getAttribute('data-tag') || '') === currentTag) {
        btn.classList.add('is-active');
      }
    });
  }

  /* ─── Spring Signatures / Featured Product Carousel ─────── */
  function initSpringSignatures() {
    var section = document.querySelector('.spring-signatures');
    if (!section) return;

    var mainImg = section.querySelector('.spring-signatures__img-wrap img');
    var mainLink = section.querySelector('.spring-signatures__img-wrap').closest('a');
    var productName = section.querySelector('.spring-signatures__product-name');
    var productPrice = section.querySelector('.spring-signatures__product-price');
    var shopLink = section.querySelector('.spring-signatures__shop-link');
    var thumbBtns = section.querySelectorAll('.spring-signatures__thumb-btn');
    var arrowUp = section.querySelector('[data-arrow="up"]');
    var arrowDown = section.querySelector('[data-arrow="down"]');
    var current = 0;
    var total = thumbBtns.length;

    function activateIndex(i) {
      current = (i + total) % total;
      thumbBtns.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current);
      });
      var active = thumbBtns[current];
      if (mainImg) mainImg.src = active.getAttribute('data-img') || '';
      if (mainLink) mainLink.href = active.getAttribute('data-url') || '';
      if (productName) productName.textContent = active.getAttribute('data-name') || '';
      if (productPrice) productPrice.textContent = active.getAttribute('data-price') || '';
      if (shopLink) shopLink.href = active.getAttribute('data-url') || '';
    }

    thumbBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { activateIndex(i); });
    });
    if (arrowUp) arrowUp.addEventListener('click', function () { activateIndex(current - 1); });
    if (arrowDown) arrowDown.addEventListener('click', function () { activateIndex(current + 1); });

    activateIndex(0);
  }

  /* ─── Lookbook Lightbox ─────────────────────────────────── */
  function initLookbookLightbox() {
    var lightbox = document.querySelector('.lightbox');
    if (!lightbox) return;
    var lightboxImg = lightbox.querySelector('.lightbox__img-wrap img');
    var lightboxCaption = lightbox.querySelector('.lightbox__caption');
    var lightboxCounter = lightbox.querySelector('.lightbox__counter');
    var closeBtn = lightbox.querySelector('.lightbox__close');
    var triggers = document.querySelectorAll('[data-lightbox]');
    var currentIdx = 0;
    var images = [];

    triggers.forEach(function (el, i) {
      images.push({
        src: el.getAttribute('data-lightbox'),
        caption: el.getAttribute('data-caption') || '',
      });
      el.addEventListener('click', function () {
        currentIdx = i;
        openLightbox();
      });
    });

    function openLightbox() {
      var img = images[currentIdx];
      if (lightboxImg) lightboxImg.src = img.src;
      if (lightboxCaption) lightboxCaption.textContent = img.caption;
      if (lightboxCounter) lightboxCounter.textContent = (currentIdx + 1) + ' / ' + images.length;
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') { currentIdx = (currentIdx + 1) % images.length; openLightbox(); }
      if (e.key === 'ArrowLeft') { currentIdx = (currentIdx - 1 + images.length) % images.length; openLightbox(); }
    });
  }

  /* ─── Newsletter ────────────────────────────────────────── */
  function initNewsletter() {
    var form = document.querySelector('.footer__newsletter-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('.footer__newsletter-input');
      var email = input ? input.value.trim() : '';
      if (!email) return;
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&email=' + encodeURIComponent(email) + '&tags=newsletter'
      }).finally(function () {
        var parent = form.parentElement;
        form.style.display = 'none';
        var msg = document.createElement('p');
        msg.className = 'footer__newsletter-success';
        msg.textContent = 'Thank you for subscribing';
        parent.appendChild(msg);
      });
    });
  }

  /* ─── LiveChat ──────────────────────────────────────────── */
  function initLiveChat() {
    var widget = document.getElementById('livechat-widget');
    if (!widget) return;

    var logoSrc = document.querySelector('meta[name="livechat-logo"]');
    var logoUrl = logoSrc ? logoSrc.content : '';

    widget.innerHTML =
      '<div class="livechat-panel" id="lc-panel">' +
        '<div class="livechat-panel__header">' +
          '<div class="livechat-panel__status"><div class="livechat-status-dot"></div>Jaffary Support</div>' +
          '<button class="livechat-panel__close" id="lc-close"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
        '</div>' +
        '<div class="livechat-panel__body" id="lc-body">' +
          '<div class="livechat-quick-opts" id="lc-quick">' +
            '<p class="livechat-how">How can we help?</p>' +
            '<p class="livechat-sub" style="font-size:12px;color:#8a8781;line-height:1.6;margin-top:6px;">You\'re chatting with the Jaffary team. Replies appear right here.</p>' +
          '</div>' +
          '<div class="livechat-msgs" id="lc-msgs" style="display:none"></div>' +
        '</div>' +
        '<div class="livechat-panel__footer">' +
          '<div class="livechat-input-wrap">' +
            '<input class="livechat-input" id="lc-input" type="text" placeholder="Ask anything...">' +
            '<button class="livechat-send-btn" id="lc-send"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button class="livechat-btn" id="lc-toggle">' +
        '<img class="livechat-btn__logo" src="' + logoUrl + '" alt="Jaffary">' +
        '<span class="livechat-btn__text">Chat with us</span>' +
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2"><path d="M18 15l-6-6-6 6"/></svg>' +
        '<span class="livechat-btn__badge" id="lc-badge">1</span>' +
      '</button>';

    var panel = document.getElementById('lc-panel');
    var toggle = document.getElementById('lc-toggle');
    var lcClose = document.getElementById('lc-close');
    var quick = document.getElementById('lc-quick');
    var msgsEl = document.getElementById('lc-msgs');
    var input = document.getElementById('lc-input');
    var sendBtn = document.getElementById('lc-send');
    var messages = [];
    var loading = false;
    var badgeEl = document.getElementById('lc-badge');
    var unread = 0;
    var HIST_KEY = 'jaffary_chat_v1';
    var UNREAD_KEY = 'jaffary_chat_unread';

    function saveHistory() {
      try { localStorage.setItem(HIST_KEY, JSON.stringify(messages.slice(-60))); } catch (e) {}
    }
    function setUnread(n) {
      unread = n;
      try { localStorage.setItem(UNREAD_KEY, String(n)); } catch (e) {}
      if (badgeEl) {
        badgeEl.textContent = n > 9 ? '9+' : String(n);
        badgeEl.classList.toggle('is-visible', n > 0);
      }
    }
    function renderStored(role, html) {
      var div = document.createElement('div');
      div.className = 'livechat-msg livechat-msg--' + (role === 'user' ? 'user' : 'ai');
      div.innerHTML = '<div class="livechat-msg__bubble">' + html + '</div>';
      msgsEl.appendChild(div);
    }
    /* Restore conversation from previous pages */
    try {
      var stored = JSON.parse(localStorage.getItem(HIST_KEY) || '[]');
      if (stored.length) {
        messages = stored;
        if (quick) quick.style.display = 'none';
        msgsEl.style.display = 'flex';
        stored.forEach(function (m) { renderStored(m.role, m.html); });
        msgsEl.scrollTop = msgsEl.scrollHeight;
      }
      setUnread(parseInt(localStorage.getItem(UNREAD_KEY) || '0', 10) || 0);
    } catch (e) {}

    // Hide button on home page and The Circle page
    function isLiveChatHiddenPage() {
      return window.location.pathname === '/' || window.location.pathname === '/pages/the-circle';
    }
    if (isLiveChatHiddenPage()) toggle.classList.add('is-hidden');

    // Cart open/close hides button
    document.addEventListener('cart-open', function () { toggle.classList.add('is-hidden'); });
    document.addEventListener('cart-close', function () { if (!isLiveChatHiddenPage()) toggle.classList.remove('is-hidden'); });

    function openPanel() {
      panel.classList.add('is-open');
      toggle.classList.add('is-hidden');
      setUnread(0);
      setTimeout(function () { if (input) input.focus(); }, 100);
    }
    function closePanel() {
      panel.classList.remove('is-open');
      if (!isLiveChatHiddenPage()) toggle.classList.remove('is-hidden');
    }

    if (toggle) toggle.addEventListener('click', openPanel);
    if (lcClose) lcClose.addEventListener('click', closePanel);

    /* Crisp = invisible engine. Its chatbox is never shown; our panel is the UI.
       Outgoing: sendMessage() pushes text into the Crisp conversation.
       Incoming: operator replies arrive via message:received and render in our panel. */
    var crispReady = false;
    (function crispSetup(tries) {
      if (window.$crisp && window.$crisp.push) {
        crispReady = true;
        window.$crisp.push(["safe", true]);
        window.$crisp.push(["do", "chat:hide"]);
        window.$crisp.push(["on", "chat:opened", function () { window.$crisp.push(["do", "chat:close"]); window.$crisp.push(["do", "chat:hide"]); }]);
        window.$crisp.push(["on", "message:received", function (message) {
          window.$crisp.push(["do", "chat:hide"]);
          var text = '';
          if (message && typeof message.content === 'string') text = message.content;
          else if (message && message.content && typeof message.content.text === 'string') text = message.content.text;
          if (!text) return;
          removeTyping();
          if (quick) quick.style.display = 'none';
          if (msgsEl) msgsEl.style.display = 'flex';
          addMsg('ai', text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>'));
          if (!panel.classList.contains('is-open')) setUnread(unread + 1);
        }]);
      } else if (tries < 40) {
        setTimeout(function () { crispSetup(tries + 1); }, 250);
      }
    })(0);

    function addMsg(role, html) {
      renderStored(role, html);
      msgsEl.scrollTop = msgsEl.scrollHeight;
      messages.push({ role: role, html: html });
      saveHistory();
    }

    function showTyping() {
      var div = document.createElement('div');
      div.className = 'livechat-msg livechat-msg--ai';
      div.id = 'lc-typing';
      div.innerHTML = '<div class="livechat-typing"><div class="livechat-typing-dot"></div><div class="livechat-typing-dot"></div><div class="livechat-typing-dot"></div></div>';
      msgsEl.appendChild(div);
      msgsEl.scrollTop = msgsEl.scrollHeight;
    }
    function removeTyping() {
      var t = document.getElementById('lc-typing');
      if (t) t.remove();
    }

    function sendMessage(text) {
      if (!text) return;
      if (quick) quick.style.display = 'none';
      if (msgsEl) msgsEl.style.display = 'flex';
      addMsg('user', text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'));
      if (input) input.value = '';

      if (crispReady && window.$crisp && window.$crisp.push) {
        window.$crisp.push(["do", "message:send", ["text", text]]);
        window.$crisp.push(["do", "chat:hide"]);
        if (messages.length === 1) {
          var note = document.createElement('div');
          note.className = 'livechat-msg livechat-msg--ai';
          note.innerHTML = '<div class="livechat-msg__bubble" style="background:transparent;color:#8a8781;font-size:11.5px;padding:4px 2px;">Delivered. We reply here — usually within minutes.</div>';
          msgsEl.appendChild(note);
          msgsEl.scrollTop = msgsEl.scrollHeight;
        }
      } else {
        /* Crisp unavailable (blocked/offline): offer direct contact instead of losing the message */
        var cfgEl = document.getElementById('livechat-config');
        var cfg = {};
        try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) {}
        var fb = document.createElement('div');
        fb.className = 'livechat-msg livechat-msg--ai';
        fb.innerHTML = '<div class="livechat-msg__bubble">Chat could not connect right now. Please email us' + (cfg.email ? ' at <a href="mailto:' + cfg.email + '">' + cfg.email + '</a>' : '') + ' and we\'ll get back to you quickly.</div>';
        msgsEl.appendChild(fb);
        msgsEl.scrollTop = msgsEl.scrollHeight;
      }
    }

    if (quick) {
      quick.querySelectorAll('.livechat-opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () { sendMessage(btn.getAttribute('data-opt')); });
      });
    }
    if (sendBtn) sendBtn.addEventListener('click', function () { sendMessage(input ? input.value.trim() : ''); });
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') sendMessage(input.value.trim()); });

    // Show after delay
    setTimeout(function () {
      if (toggle && !isLiveChatHiddenPage()) toggle.classList.remove('is-hidden');
    }, 1500);
  }

  /* ─── Marquee ───────────────────────────────────────────── */
  function initMarquee() {
    var track = document.querySelector('.marquee__track');
    if (!track) return;
    // Clone for seamless loop
    var clone = track.cloneNode(true);
    track.parentNode.appendChild(clone);
  }

  /* ─── Refine overlay (shop page) ────────────────────────── */
  function initRefine() {
    var overlay = document.querySelector('.refine-overlay');
    var openBtn = document.querySelector('[data-refine-open]');
    var closeBtn = document.querySelector('[data-refine-close]');
    var clearBtn = document.querySelector('.refine-clear-btn');
    if (!overlay || !openBtn) return;

    openBtn.addEventListener('click', function () {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Section buttons
    var sectionBtns = overlay.querySelectorAll('.refine-section-btn');
    var optionPanels = overlay.querySelectorAll('[data-refine-panel]');
    sectionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-target');
        optionPanels.forEach(function (p) { p.style.display = p.getAttribute('data-refine-panel') === target ? 'flex' : 'none'; });
      });
    });
    if (sectionBtns.length) sectionBtns[0].click();
  }

  /* ─── PDP carousels (Complete The Look / You May Also Like) ─ */
  function initPdpCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var progressBar = carousel.parentElement
        && carousel.parentElement.querySelector('.gallery-progress__bar');
      if (!progressBar) return;

      var slides = carousel.querySelectorAll('.pdp-carousel__slide');
      var total = slides.length;
      if (!total) return;

      function updateProgress() {
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (maxScroll <= 0) {
          progressBar.style.width = '100%';
          progressBar.style.transform = 'translateX(0%)';
          return;
        }
        var ratio = carousel.scrollLeft / maxScroll;
        var barW = 100 / total;
        progressBar.style.width = barW + '%';
        progressBar.style.transform = 'translateX(' + (ratio * (total - 1) * 100) + '%)';
      }

      carousel.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    });
  }

  /* ─── Init ──────────────────────────────────────────────── */
  function init() {
    initFadeIn();
    initHeader();
    initMenu();
    initSearch();
    initCart();
    initProductGallery();
    initPdpCarousels();
    initSizeSelector();
    initAccordions();
    // Persist full-black fill on homepage pill buttons after click
    document.querySelectorAll('.hero__cta-btn--link, .hero__cta-desktop-btn, .upr-item__btn').forEach(function (b) {
      b.addEventListener('click', function () { b.classList.add('is-pressed'); });
    });
    initFooterAccordion();
    initCollectionFilter();
    initSpringSignatures();
    initLookbookLightbox();
    initNewsletter();
    // Homepage: show live chat only after 10 seconds
    if (document.body.dataset.pageType === 'index' || location.pathname === '/') {
      var lcw = document.getElementById('livechat-widget');
      if (lcw) lcw.style.display = 'none';
      setTimeout(function () {
        if (lcw) lcw.style.display = '';
        initLiveChat();
      }, 10000);
    } else {
      initLiveChat();
    }
    initMarquee();
    initRefine();
    initProductCardGalleries();
    window.jaffaryInitCardGalleries = initProductCardGalleries;
    initWishlistToggle();
  }

  /* ─── Product card swipeable galleries (grid + related sections) ─── */
  function initProductCardGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = '1';
      var card = gallery.closest('.product-card');
      if (!card) return;
      var thumb = card.querySelector('[data-product-gallery-thumb]');
      if (!thumb) return;

      function updateThumb() {
        var clientWidth = gallery.clientWidth || 1;
        var slide = Math.round(gallery.scrollLeft / clientWidth);
        thumb.style.transform = 'translateX(' + (slide * 100) + '%)';
      }

      gallery.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateThumb);
      }, { passive: true });

      updateThumb();
    });
  }

  /* ─── Wishlist Toggle (product cards + product page) ────── */
  var wishlistStorageKey = 'jaffary-wishlist';

  function getWishlistHandles() {
    try { return JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlistHandles(arr) {
    localStorage.setItem(wishlistStorageKey, JSON.stringify(arr));
  }

  function bindWishlistButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound === '1') return;
      btn.dataset.wishlistBound = '1';

      var handle = btn.getAttribute('data-product-handle');
      var label = btn.querySelector('[data-wishlist-label]');
      if (!handle) return;

      function refresh() {
        var saved = getWishlistHandles().indexOf(handle) !== -1;
        btn.classList.toggle('is-saved', saved);
        if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Save to Wishlist';
      }

      refresh();

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handles = getWishlistHandles();
        var idx = handles.indexOf(handle);
        if (idx === -1) {
          handles.push(handle);
        } else {
          handles.splice(idx, 1);
        }
        saveWishlistHandles(handles);
        refresh();
        document.dispatchEvent(new CustomEvent('wishlist:changed'));
      });
    });
  }

  function refreshWishlistCountBadges() {
    var count = getWishlistHandles().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function initWishlistToggle() {
    bindWishlistButtons(document);
    refreshWishlistCountBadges();
    document.addEventListener('wishlist:changed', refreshWishlistCountBadges);
    document.addEventListener('rv:rendered', function () { bindWishlistButtons(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── Recently Viewed: Track (product pages) + Render (collection page) ──────
(function() {
  var RV_KEY = 'jaffary_rv';
  var MAX_RV = 8;
  var pageType = document.body.dataset.pageType;

  // Read the stored list defensively: legacy data from the old React site
  // (same key, different format) or corruption must not kill the feature.
  function readRV() {
    var rv = [];
    try { rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { rv = []; }
    if (!Array.isArray(rv)) rv = [];
    return rv.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h); });
  }

  // Track: on product pages save current handle to front of localStorage list
  if (pageType === 'product') {
    var wishlistBtn = document.querySelector('[data-wishlist-toggle][data-product-handle]');
    var handle = (wishlistBtn && wishlistBtn.dataset.productHandle) || document.body.dataset.productHandle || null;
    if (handle) {
      var rv = readRV();
      rv = rv.filter(function(h) { return h !== handle; });
      rv.unshift(handle);
      if (rv.length > MAX_RV) rv = rv.slice(0, MAX_RV);
      try { localStorage.setItem(RV_KEY, JSON.stringify(rv)); } catch (e) {}
    }
  }

  // Render: on collection pages load recently viewed products via AJAX
  if (pageType === 'collection' || pageType === 'product') {
    var rvSection = document.getElementById('recently-viewed-section');
    var rvTrack  = document.getElementById('recently-viewed-track');
    if (!rvSection || !rvTrack) return;

    var handles = readRV();
    var currentHandle = document.body.dataset.productHandle;
    if (currentHandle) handles = handles.filter(function (h) { return h !== currentHandle; });
    if (handles.length === 0) return;

    var fetched = new Array(handles.length);
    var pending = handles.length;

    handles.forEach(function(h, idx) {
      fetch('/products/' + h + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { fetched[idx] = p; })
        .catch(function() {})
        .finally(function() {
          pending--;
          if (pending === 0) renderRV();
        });
    });

    function renderRV() {
      var cards = fetched.filter(Boolean);
      if (cards.length === 0) return;

      cards.forEach(function(p) {
        var name   = titleCaseRV(p.title);
        var price  = jaffaryMoney(p.price);
        var imgs   = (p.images && p.images.length ? p.images : (p.featured_image ? [p.featured_image] : []));
        if (imgs.length > 2) imgs = imgs.slice(0, 2); /* recently-viewed cards: max 2 images */
        var slides = imgs.map(function (u) {
          var src = u + (u.indexOf('?') > -1 ? '&width=700' : '?width=700');
          return '<div class="product-card__slide"><img src="' + src + '" alt="' + name.replace(/"/g,'&quot;') + '" loading="lazy" draggable="false"></div>';
        }).join('');
        if (!slides) slides = '<div class="product-card__slide"><div class="product-card__img-placeholder"></div></div>';
        var track = imgs.length > 1
          ? '<div class="product-card__slide-track" data-product-gallery-track aria-hidden="true"><div class="product-card__slide-thumb" data-product-gallery-thumb style="width:' + (100 / imgs.length) + '%;"></div></div>'
          : '';

        var item = document.createElement('div');
        item.className = 'recently-viewed__item';
        item.innerHTML =
          '<div class="product-card">' +
            '<div class="product-card__top-row">' +
              '<span class="product-card__label">' + (p.available ? 'New In' : 'Sold Out') + '</span>' +
              '<button type="button" class="product-card__wishlist-btn" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-label="Save to wishlist">' +
                '<svg width="16" height="20" viewBox="0 0 16 20" fill="none" stroke="currentColor" stroke-width="1"><path d="M2 1h12v18l-6-4-6 4V1z"/></svg>' +
              '</button>' +
            '</div>' +
            '<a href="/products/' + p.handle + '" class="product-card__img-wrap" aria-label="' + name.replace(/"/g,'&quot;') + '">' +
              '<div class="product-card__gallery" data-product-gallery>' + slides + '</div>' +
            '</a>' +
            track +
            '<div class="product-card__info">' +
              '<a href="/products/' + p.handle + '" class="product-card__link">' +
                '<p class="product-card__name">' + name + '</p>' +
                '<p class="product-card__price"><span data-price-usd="' + p.price + '">' + price + '</span></p>' +
              '</a>' +
            '</div>' +
          '</div>';
        rvTrack.appendChild(item);
      });

      if (window.jaffaryInitCardGalleries) window.jaffaryInitCardGalleries();
      rvSection.style.display = '';
      document.dispatchEvent(new CustomEvent('rv:rendered'));
    }
  }

  function titleCaseRV(str) {
    return String(str || '').toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
})();

// ─── Color Selector Panel ────────────────────────────────────────────────────
(function() {
  var colorPanel   = document.getElementById('color-panel');
  if (!colorPanel) return;
  var overlay  = document.getElementById('color-panel-overlay');
  var closeBtn = document.getElementById('color-panel-close');
  var openBtns = document.querySelectorAll('[data-open-color-panel]');

  function openColorPanel() {
    colorPanel.classList.add('is-open');
    colorPanel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeColorPanel() {
    colorPanel.classList.remove('is-open');
    colorPanel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function(btn) { btn.addEventListener('click', openColorPanel); });
  if (overlay)  overlay.addEventListener('click', closeColorPanel);
  if (closeBtn) closeBtn.addEventListener('click', closeColorPanel);
  colorPanel.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeColorPanel(); });
})();

/* ─── Size Guide Panel Dropdowns ─────────────────────────────── */
(function(){
  var sizes=[
    {lv:44,intl:'XXS',USA:26,'FRANCE/UK':36,GERMANY:36,ITALY:44,CANADA:26,SPAIN:36,wCm:74,hCm:91},
    {lv:46,intl:'XS', USA:28,'FRANCE/UK':38,GERMANY:38,ITALY:46,CANADA:28,SPAIN:38,wCm:77,hCm:94},
    {lv:48,intl:'S',  USA:30,'FRANCE/UK':40,GERMANY:40,ITALY:48,CANADA:30,SPAIN:40,wCm:80,hCm:97},
    {lv:50,intl:'M',  USA:32,'FRANCE/UK':42,GERMANY:42,ITALY:50,CANADA:32,SPAIN:42,wCm:83,hCm:100},
    {lv:52,intl:'L',  USA:34,'FRANCE/UK':44,GERMANY:44,ITALY:52,CANADA:34,SPAIN:44,wCm:86,hCm:103},
    {lv:54,intl:'XL', USA:36,'FRANCE/UK':46,GERMANY:46,ITALY:54,CANADA:36,SPAIN:46,wCm:89,hCm:106},
    {lv:56,intl:'XXL',USA:38,'FRANCE/UK':48,GERMANY:48,ITALY:56,CANADA:38,SPAIN:48,wCm:92,hCm:109},
    {lv:58,intl:'XXXL', USA:40,'FRANCE/UK':50,GERMANY:50,ITALY:58,CANADA:40,SPAIN:50,wCm:95,hCm:112},
    {lv:60,intl:'XXXXL', USA:42,'FRANCE/UK':52,GERMANY:52,ITALY:60,CANADA:42,SPAIN:52,wCm:98,hCm:115},
    {lv:62,intl:'XXXXXL',USA:44,'FRANCE/UK':54,GERMANY:54,ITALY:62,CANADA:44,SPAIN:54,wCm:101,hCm:118}
  ];
  function fmt(cm){ return cm+' cm - '+(cm/2.54).toFixed(1)+'"'; }
  function initSgPanel(){
    var cSel=document.getElementById('sgp-country');
    var sSel=document.getElementById('sgp-size');
    var wEl=document.getElementById('sgp-waist');
    var hEl=document.getElementById('sgp-hips');
    if(!cSel||!sSel||!wEl||!hEl) return;
    if(sSel._sgInit) return; // already wired
    sSel._sgInit=true;
    function buildSizes(){
      var c=cSel.value; sSel.innerHTML='';
      sizes.forEach(function(s,i){
        var o=document.createElement('option');
        o.value=i;
        o.textContent='SIZE (ITALY) - '+s.lv+' / '+c+' - '+s[c]+' / INTERNATIONAL - '+s.intl;
        sSel.appendChild(o);
      });
      updateMeasure();
    }
    function updateMeasure(){
      var s=sizes[parseInt(sSel.value,10)];
      if(!s)return;
      wEl.textContent=fmt(s.wCm);
      hEl.textContent=fmt(s.hCm);
    }
    cSel.addEventListener('change',buildSizes);
    sSel.addEventListener('change',updateMeasure);
    buildSizes();
  }
  function getLcToggle(){ return document.getElementById('lc-toggle'); }
  // Run on load and also whenever the sizeguide panel opens
  document.addEventListener('DOMContentLoaded', initSgPanel);
  document.addEventListener('click', function(e){
    if(e.target && e.target.closest && e.target.closest('[data-open-sizeguide]')){
      setTimeout(initSgPanel, 50);
      // Hide LiveChat while sizeguide is open
      var t=getLcToggle(); if(t) t.classList.add('is-hidden');
    }
  });
  // Restore LiveChat when sizeguide panel closes
  document.addEventListener('click', function(e){
    if(e.target && e.target.closest){
      if(e.target.closest('#sizeguide-panel-close') || e.target.closest('#sizeguide-panel-overlay')){
        var t=getLcToggle(); if(t) t.classList.remove('is-hidden');
      }
    }
  });
})();

// ── Hero video: fade in only when fully ready (avoids blurry first frames) ──
(function(){
  var heroVid = document.querySelector('.hero video');
  if(!heroVid) return;
  function markReady(){ heroVid.classList.add('is-ready'); }
  if(heroVid.readyState >= 4){ markReady(); return; }
  heroVid.addEventListener('canplaythrough', markReady, {once:true});
  // Fallback: show after 3s regardless (slow connections)
  setTimeout(markReady, 3000);
})();

/* ── Never show two logos at once: hide the header logo while the
      footer logo is anywhere in the viewport ─────────────────────── */
(function () {
  var footerLogo = document.querySelector('.footer__logo');
  var headerLogo = document.querySelector('.header-logo');
  if (!footerLogo || !headerLogo || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      headerLogo.style.opacity = e.isIntersecting ? '0' : '';
      headerLogo.style.pointerEvents = e.isIntersecting ? 'none' : '';
      headerLogo.style.transition = 'opacity .25s';
    });
  }, { threshold: 0 });
  io.observe(footerLogo);
})();
